/** Skip the next URL→i18n sync when the language change came from the UI selector. */
let skipUrlLanguageApply = false;

export const setSkipUrlLanguageApply = (): void => {
  skipUrlLanguageApply = true;
};

export const consumeSkipUrlLanguageApply = (): boolean => {
  if (!skipUrlLanguageApply) {
    return false;
  }
  skipUrlLanguageApply = false;
  return true;
};
